import CacheUtil from "../../../../../shared/lib/html5-software-library/src/ranj/util/CacheUtil";
import { getURLParameter } from "../../../../../shared/lib/html5-software-library/src/ranj/util/URLUtil";
import GameConfig from "../model/GameConfig";

export default class RoadBuilder {

    /**
     * @param {GameConfig} gameConfig 
     * @param {Object} roadAssets 
     */
    constructor(gameConfig, roadAssets) {
        this._config = gameConfig;
        this._roadAssets = roadAssets;

        this._laneWidth = this._config.getValue("laneWidth");
        this._sectionLength = this._config.getValue("sectionLength");
        this._tileHeight = this._config.getValue("tileHeight");
        this._shapesDeltaY = this._config.getValue("shapesSpacing");
        this._shapesScale = this._config.getValue("shapesScale");
        this._roadTypes = this._config.getValue("roadTypes");

        if (!isNaN(parseInt(getURLParameter("dy")))) {
            this._shapesDeltaY = parseInt(getURLParameter("dy"));
        }
        //Make sure shapes tile nicely:
        this._shapesDeltaY = this._sectionLength / Math.round(this._sectionLength / this._shapesDeltaY);
        
        if (!isNaN(parseFloat(getURLParameter("scale")))) {
            this._shapesScale = parseFloat(getURLParameter("scale"));
        }
    }

    build(sectionsContainer, markersContainer) {
        const cacheEnabled = getURLParameter("cache") != "0";
        const sectionCfgs = this._config.sections;
        const dx = this._laneWidth;
        const dy = -this._sectionLength;
        let y = 0;
        const n = this._config.laneCount;
        const sectionSkins = sectionCfgs.map((sectionCfg, idx) => {

            const skin = sectionsContainer.addChild(new createjs.Container());
            const x0 = -dx * .5 * (n - 1);
            sectionCfg.lanes.forEach((laneCfg, laneIdx) => {
                const colorTileId = this._config.getLaneTileSkin(laneCfg.color);
                const shapeId = this._config.getLaneTileSkin(laneCfg.shape);
                const laneSkin = this._buildLaneSkin(colorTileId, shapeId);
                skin.addChild(laneSkin);
                laneSkin.x = x0 + laneIdx * dx;
            });
            if (sectionCfg.marker) {
                const { skin: markerSkinId, position } = sectionCfg.marker;
                const markerSkin = markersContainer.addChild(new this._roadAssets[markerSkinId]());
                if (markerSkin.bg) {
                    markerSkin.bg.scaleX = n;
                }
                markerSkin.y = y - position - (position < 0 ? this._sectionLength : 0);
            }
            skin.y = y;
            y += dy;
            skin.index = idx++;
            if (cacheEnabled) {
                CacheUtil.cache(skin);
                skin.removeAllChildren();
            }
            return skin;
        });

        return sectionSkins;
    }

    _buildLaneSkin(colorTileId, shapeId) {
        const skin = new createjs.Container();
        //Color tiles:
        const colorTileClass = this._roadAssets[colorTileId];
        const nTiles = Math.ceil(this._sectionLength / this._tileHeight);
        const dy = -this._tileHeight;
        for (let i = 0; i < nTiles; i++) {
            skin.addChild(new colorTileClass()).y = i * dy;
        }
        //Shapes:
        const shapeClass = shapeId ? this._roadAssets[shapeId] : null;
        if (shapeClass) {
            const nShapes = Math.round(this._sectionLength / this._shapesDeltaY);
            const y0 = -this._shapesDeltaY / 2;
            for (let i = 0; i < nShapes; i++) {
                const shape = skin.addChild(new shapeClass());
                shape.y = y0 + i * -this._shapesDeltaY;
                shape.scaleX = shape.scaleY = this._shapesScale;
            }
        }
        return skin;
    }

    _getTileClass(id) {

    }

}